/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface ProgramReferencesCountsDto
 */
export interface ProgramReferencesCountsDto {

    /**
     * Distinct assignments
     *
     * @type {number}
     * @memberof ProgramReferencesCountsDto
     */
    assignments: number;

    /**
     * Distinct members
     *
     * @type {number}
     * @memberof ProgramReferencesCountsDto
     */
    members: number;
}
